var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dropdown",
    {
      staticClass: "notification-center",
      attrs: { trigger: "click" },
      on: { command: _vm.onCommand },
    },
    [
      _c(
        "span",
        { staticClass: "notification-center__trigger" },
        [
          _c(
            "el-badge",
            {
              attrs: {
                value: _vm.totalCount,
                hidden: _vm.totalCount === 0,
                type: "warning",
              },
            },
            [_c("i", { staticClass: "fa fa-bell fa-fw fa-lg" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "notification-center__menu",
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        [
          _vm._l(_vm.notifications, function (item, index) {
            return _c(
              "el-dropdown-item",
              { key: index, attrs: { command: item.url } },
              [
                _c("span", { staticClass: "notification-center__item" }, [
                  _c("i", {
                    staticClass: "notification-center__icon",
                    class: _vm.iconFor(item.type),
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "notification-center__message" }, [
                    _vm._v(_vm._s(item.message)),
                  ]),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.notifications.length === 0
            ? _c("el-dropdown-item", { attrs: { disabled: "" } }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "notification-center__item notification-center__item--empty",
                  },
                  [
                    _c("i", {
                      staticClass:
                        "far fa-bell-slash notification-center__icon",
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "notification-center__message" },
                      [_vm._v("No notifications")]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }